import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddGroupCode } from '../../../models/forms/IAddUpdateGroupCode';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import AddEditCodeForm from '../forms/add-edit-code-form';

interface IProps extends IFormModalProps {
  selectedAssignedRows: any;
}

const AddEditCode = (props: IProps) => {
  const { processStore, groupSettingStore } = useStore();
  const { GetProcessByIdService, resetProcessDetail } = processStore;
  const { AddGroupCodeService, addGroupCodeState, resetAddGroupCodeState } =
    groupSettingStore;

  const initialValues = { CodeName: '' };

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetProcessByIdService(props.id);
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addGroupCodeState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addGroupCodeState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addGroupCodeState.error) {
      toast.error(formatMessage(addGroupCodeState.error));
      resetAddGroupCodeState();
    }
  }, [addGroupCodeState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values) => {
    var addObj: IAddGroupCode = {
      ...values,
      TrayId: props.selectedAssignedRows.join(','),
      TenantId: Number(getTenantIdFromLocalStorage()),
    };

    if (props.id < 0) {
      AddGroupCodeService(addObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetProcessDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="correction-modal fancy-modal"
        addHeader="assign_group_code"
        updateHeader="update_process"
        onModalClosed={onModalClosed}
        isLoading={addGroupCodeState.inProgress}
      >
        <AddEditCodeForm
          id={props.id}
          initialValues={initialValues}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={addGroupCodeState.inProgress}
          selectedRows={props.selectedAssignedRows}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(AddEditCode);
